import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FavoritesContext = createContext(null);

export function FavoritesProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState(new Set());

  useEffect(() => {
    if (!user || user === false) {
      setIds(new Set());
      return;
    }
    api.get("/favorites").then((r) => {
      setIds(new Set((r.data || []).map((f) => f.project_id)));
    }).catch(() => {});
  }, [user]);

  const toggle = async (projectId) => {
    if (!user || user === false) return { needsAuth: true };
    if (ids.has(projectId)) {
      await api.delete(`/favorites/${projectId}`);
      setIds((prev) => {
        const next = new Set(prev);
        next.delete(projectId);
        return next;
      });
    } else {
      await api.post(`/favorites/${projectId}`);
      setIds((prev) => new Set([...prev, projectId]));
    }
    return { ok: true };
  };

  const has = (id) => ids.has(id);

  return (
    <FavoritesContext.Provider value={{ ids, toggle, has, count: ids.size }}>
      {children}
    </FavoritesContext.Provider>
  );
}

export const useFavorites = () => useContext(FavoritesContext);
